import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import styles from './index.less'

interface PriceRollerProps {
  value: number;
  height?: number;    // 单行高度，单位 px
  duration?: number;  // 动画时长，秒
  style?: React.CSSProperties;
  key?: string;
  priceClassName?: string;
  tipClassName?: string;
}

export default function PriceRoller({
  value,
  height = 60,
  duration = 0.5,
  style,
  key,
  priceClassName,
  tipClassName,
}: PriceRollerProps) {
  const [prev, setPrev] = useState<number>(value);
  const [pair, setPair] = useState<[number, number]>([value, value]);
  const [animating, setAnimating] = useState<boolean>(false);
  const [direction, setDirection] = useState<"up" | "down" | null>(null);

  useEffect(() => {
    if (value === prev) return;

    if (value < prev) {
      // 降价：旧值在上，新值在下，向上滚动 (y: 0 -> -height)
      setPair([prev, value]);
      setDirection("up");
      setAnimating(true);
    } else {
      // 涨价：为了实现“从上方出现”的视觉，需要把新值放在上面，
      // 并从初始偏移 -height 开始平移到 0（整体往下）
      setPair([value, prev]);
      setDirection("down");
      setAnimating(true);
    }
  }, [value]);

  // 动画期间渲染 motion.div（两行）
  if (animating && direction) {
    const initialY = direction === "up" ? 0 : -height; // px
    const animateY = direction === "up" ? -height : 0;

    return (
      <div
        key={key}
        style={{
          overflow: "hidden",
          height,
          display: "inline-block",
          lineHeight: `${height}px`,
          ...style,
        }}
      >
        <motion.div
          initial={{ y: initialY }}
          animate={{ y: animateY }}
          transition={{ duration, ease: "easeInOut" }}
          onAnimationComplete={() => {
            // 动画结束：替换为静态显示新值（prev <- value）
            setPrev(value);
            setAnimating(false);
            setDirection(null);
            setPair([value, value]);
          }}
          style={{ willChange: "transform" }}
        >
          {pair.map((num, i) => (
            <div
              key={i}
              className={priceClassName}
              style={{
                height,
                // fontSize: height * 0.8,
                // fontWeight: 700,
                textAlign: "center",
                display:'flex',
                alignItems:'center',
                justifyContent:'center'
              }}
            >
              <div className={tipClassName}>￥</div> 
              {num}
            </div>
          ))}
        </motion.div>
      </div>
    );
  }

  // 非动画时只渲染单行静态值（这样切换回去是“立刻”的，没有动画）
  return (
    <div
      key={key}
      style={{
        overflow: "hidden",
        height,
        display: "inline-block",
        lineHeight: `${height}px`,
        ...style,
      }}
    >
      <div
        style={{
          height,
        //   fontSize: height * 0.8,
        //   fontWeight: 700,
          textAlign: "center",
          display:'flex',
          alignItems:'center',
          justifyContent:'center'
        }}
        className={priceClassName}
      >
          <div className={tipClassName}>￥</div> 
          {prev}
      </div>
    </div>
  );
}
